export default Object.freeze({
  city: 'city',
  cityAndCountry: 'cityAndCountry',
  minimalUrban: 'minimalUrban',
  adventurer: 'adventurer',
  inAHurry: 'inAHurry',
});
